import { render } from "./DEPRECATD_CRM_Customer_Dialog.vue?vue&type=template&id=70da68b1&scoped=true"
import script from "./DEPRECATD_CRM_Customer_Dialog.vue?vue&type=script&lang=js"
export * from "./DEPRECATD_CRM_Customer_Dialog.vue?vue&type=script&lang=js"

import "./DEPRECATD_CRM_Customer_Dialog.vue?vue&type=style&index=0&id=70da68b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70da68b1"]])

export default __exports__